<template>
  <UiComponentContainer
    class="highlighted-guides"
    :class="props.theme"
  >
    <UiComponentHeading
      as="paragraph"
      :level="3"
      :theme="props.theme"
    >
      <slot />
    </UiComponentHeading>
    <UiComponentWrapper class="list">
      <NuxtLink
        v-for="{ id, title, slug } in props.items"
        :key="`item-${id}`"
        class="item"
        :to="localePath({
          name: 'resources-guides-slug',
          params: {
            slug,
          },
        })"
      >
        {{ title }}
        <UiComponentIcon
          :theme="props.theme"
          type="arrow-right"
        />
      </NuxtLink>
    </UiComponentWrapper>
  </UiComponentContainer>
</template>

<script setup>
// Composables
const localePath = useLocalePath()

// Props
const props = defineProps({
  items: {
    required: true,
    type: Array,
  },
  theme: {
    default() {
      return 'light'
    },
    required: false,
    type: String,
    validator(value) {
      return ['dark', 'light'].indexOf(value) !== -1
    },
  },
})
</script>

<style scoped>
.highlighted-guides {
  @apply flex-col gap-6 pt-14;

  @screen md {
    @apply gap-10 pt-26;
  }

  &.dark {
    .list {
      .item {
        @apply text-white/80;
      }
    }
  }

  &.light {
    .list {
      .item {
        @apply text-winter-green-900;
      }
    }
  }

  .list {
    @apply flex-col gap-2;

    @screen md {
      @apply flex-row flex-wrap gap-x-10;
    }

    .item {
      @apply flex items-center gap-2 w-full py-4 font-bold text-origin leading-none;

      @screen md {
        width: calc((100% - 40px) / 2);
      }

      @screen xl {
        width: calc((100% - 120px) / 4);
      }

      &:hover {
        .icon {
          @apply translate-x-2;
        }
      }

      .icon {
        @apply text-base leading-none transform transition-transform duration-500 ease-in-out;
      }
    }
  }
}
</style>
